import { IInput, ItemTypes } from '../interfaces';
import { generateProps, generateRules } from './generate';

import { SimpleItem } from 'devextreme-react/form';
import { defaultIInputs } from '../defaults';

const InputBlock = (input: IInput) => {
    return (
        <SimpleItem {...generateProps(input, defaultIInputs[ItemTypes.Block])}>
            {generateRules(input, defaultIInputs[ItemTypes.Block])}
        </SimpleItem>
    );
};

export default InputBlock;
